import React, { useState } from 'react';
import { Badge, Col, Input, List, Modal, Row, Spin } from 'antd';
import InlineMessage from '../../atoms/InlineMessage';
import ProductSelect from '../../molecules/ProductSelect';
import FormValueSelector from '../../../containers/FormValueSelector';

const { Search } = Input;

const ProductListModal = ({
  handleSubmit,
  submitting,
  visible,
  onCancel,
  productList,
  loading,
  rejected,
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  return (
    <Modal
      confirmLoading={submitting}
      onCancel={onCancel}
      onOk={handleSubmit}
      okText={!productList.length ? 'Ok' : 'Add Products'}
      title={
        <Row justify="space-between" type="flex">
          <Col>
            Select Existing Products to Add
            <FormValueSelector selector={(select, form, sectionPrefix, values) => values}>
              {values => {
                return (
                  <Badge
                    count={values && values.filter(n => n).length}
                    style={{ backgroundColor: '#52c41a', marginLeft: 5 }}
                  />
                );
              }}
            </FormValueSelector>
          </Col>
          <Col>
            <Search
              size="large"
              placeholder="Search by product name or ID"
              enterButton
              onSearch={setSearchTerm}
              style={{ width: 300 }}
            />
          </Col>
        </Row>
      }
      visible={visible}
      style={{
        top: 20,
        minWidth: 500,
      }}
      width="80%"
    >
      <Spin spinning={loading}>
        {!loading && rejected && (
          <InlineMessage type="error" message="Could not load existing products." />
        )}
        {!loading && !rejected && !productList.length && (
          <InlineMessage message="All available products have been added." />
        )}

        <form onSubmit={handleSubmit}>
          <List
            rowKey="product_id"
            grid={{
              gutter: 50,
              xs: 2,
              sm: 3,
              md: 4,
              lg: 5,
              xl: 5,
              xxl: 5,
            }}
            pagination={{ pageSize: 18 }}
            dataSource={productList.filter(p => {
              return (
                p.name.toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0 ||
                p.product_id === parseInt(searchTerm, 10)
              );
            })}
            renderItem={product => (
              <List.Item>
                <ProductSelect product={product} />
              </List.Item>
            )}
          />
        </form>
      </Spin>
    </Modal>
  );
};

export default ProductListModal;
